var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"py-3"},[_c('TariffSetting')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }